export default __webpack_public_path__ + "static/media/ChrisHite.a2d5e4d2.jpg";